import React, { useState, useEffect } from 'react';
import styles from './ImageCarousel.module.css';
import FeaturedOffers from './FeaturedOffers';

const ImageCarousel = ({ images = [], featuredProducts = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [autoplay, setAutoplay] = useState(true);

  // Imágenes por defecto si no se proporcionan
  const defaultImages = [
    '/Ropa.png',
    '/electronicos.jpg',
    '/hogar.jpg',
  ];

  const carouselImages = images.length > 0 ? images : defaultImages;

  // Autoplay del carrusel
  useEffect(() => {
    if (!autoplay || carouselImages.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % carouselImages.length);
    }, 5000); // Cambia de imagen cada 5 segundos

    return () => clearInterval(interval);
  }, [autoplay, carouselImages.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index % carouselImages.length);
    setAutoplay(false);
    // Reactiva el autoplay después de 10 segundos
    setTimeout(() => setAutoplay(true), 5000);
  };

  const goToPrevious = () => {
    goToSlide(currentIndex - 1);
  };

  const goToNext = () => {
    goToSlide(currentIndex + 1);
  };

  if (carouselImages.length === 0) {
    return <div className={styles.carousel}>No hay imágenes disponibles</div>;
  }

  return (
    <div
      className={styles.carousel}
      onMouseEnter={() => setAutoplay(false)}
      onMouseLeave={() => setAutoplay(true)}
    >
      {/* Contenedor de imágenes */}
      <div className={styles.carouselTrack}>
        {carouselImages.map((image, index) => (
          <div
            key={index}
            className={`${styles.slide} ${index === currentIndex ? styles.slideActive : ''
              }`}
          >
            <img
              src={image}
              alt={`Slide ${index + 1}`}
              className={styles.slideImage}
              width={1920}
              height={650}
              loading={index === 0 ? 'eager' : 'lazy'}
              fetchpriority={index === 0 ? 'high' : 'low'}
              decoding="async"
            />
            {/* Degradado sobrepuesto 
            <div className={styles.slideGradient}></div>*/}
          </div>
        ))}
      </div>

      {/* Contenido de hero */}
      <div className={styles.heroContent}>
        <h1>Bienvenido Nexa Global</h1>
        <p>Si existe, esta en nexa</p>
      </div>

      {/* Ofertas destacadas sobre el carrusel */}
      <div className={styles.featuredOffersContainer}>
        <FeaturedOffers products={featuredProducts} />
      </div>

      {/* Controles de navegación */}
      <button
        className={`${styles.navBtn} ${styles.prevBtn}`}
        onClick={goToPrevious}
        aria-label="Imagen anterior"
      >
        ❮
      </button>
      <button
        className={`${styles.navBtn} ${styles.nextBtn}`}
        onClick={goToNext}
        aria-label="Siguiente imagen"
      >
        ❯
      </button>

      {/* Indicadores de puntos */}
      <div className={styles.indicators}>
        {carouselImages.map((_, index) => (
          <button
            key={index}
            className={`${styles.dot} ${index === currentIndex ? styles.dotActive : ''
              }`}
            onClick={() => goToSlide(index)}
            aria-label={`Ir a slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageCarousel;
